import { render, staticRenderFns } from "./NewExpenseForm.vue?vue&type=template&id=38e68842&"
import script from "./NewExpenseForm.vue?vue&type=script&lang=js&"
export * from "./NewExpenseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports